module.exports = __webpack_public_path__ + "Flag-891.a21bd8fd63f8c1bcb01dbacff5e4af9f.svg";